import React, { memo } from 'react';

import style from './style.module.scss';

interface IProps {
  sum: string;
}

const Tooltip: React.FC<IProps> = memo(({ sum }) => <div className={style.tooltip}>{sum}</div>);

export default Tooltip;
